<template>
  <div class="add-mileage">
    <div class="header">
      <h1>Opgeven</h1>
    </div>
    <p>Geef vóór het rijden de KM-stand op en geef aan wie gereden heeft. Het aantal kilometers wordt automatisch berekend op basis van de eerder ingevulde KM-stand.</p>
    <p v-if="latestMileageUser">De vorige KM-stand is ingevoerd door <span class="black">{{latestMileageUser.firstname}}</span></p>
    <div class="input">
      <div class="field">
        <p>KM-stand:</p>
        <input type="number" v-model="mileage">
      </div>
      <div class="field">
        <p>Gebruiker:</p>
        <div class="select">
          <div :class="['item', userId === user_.id ? 'selected' : '', key === 0 ? 'first' : '', key === users.length - 1 ? 'last' : '']"
            v-for="(user_, key) in users"
            :key="user_.id"
            @click="selectUser(user_.id)">

            {{user_.firstname}}
          </div>
        </div>
      </div>
    </div>
    <p v-if="canSave">De laatst opgegeven kilometerstand is <span class="black">{{latestMileage.mileage}}</span> km. <span class="black">{{user.firstname}}</span> heeft <span class="black">{{mileage - latestMileage.mileage}}</span> km gereden.</p>
    <div class="footer">
      <button :disabled="loading || !canSave" @click="save">Opslaan</button>
      <button @click="close">Annuleren</button>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode';

export default {
  name: 'AddMileage',
  data() {
    return {
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      latestMileage: {},
      mileage: 0,
      loading: false,
      users: [],
      userId: 0
    }
  },
  methods: {
    selectUser(id) {
      this.userId = id;
    },
    save() {
      const token = localStorage.getItem('token');
      this.loading = true;

      this.axios.post(this.config.api + '/mileage', {
        userId: this.userId,
        mileage: parseInt(this.mileage),
        timestamp: Date.now()
      }, {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.loading = false;
          if (result.data.status) {
            this.$emit('update');
            this.$emit('close');
          }
          else alert(result.data.message);
        })
        .catch((error) => {
          this.loading = false;
          alert(error.message)
        })
    },
    getLatestMileage() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + '/mileage/latest', {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.latestMileage = result.data;
          this.mileage = this.latestMileage.mileage;
        })
        .catch(() => {

        })
    },
    getUsers() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + `/users`, {
          headers: {
            authorization: token
          }
        })
        .then(result => {
          this.users = result.data;
        })
        .catch(() => {

        })
    },
    close() {
      this.$emit('close');
    }
  },
  computed: {
    user: function() {
      if (!this.userId) return {};

      return this.users.find(user => user.id === this.userId);
    },
    canSave: function() {
      return this.userId && this.latestMileage.mileage;
    },
    latestMileageUser: function() {
      if (this.users.length === 0 || !this.latestMileage.userId) return;

      const user = this.users.find(user => user.id === this.latestMileage.userId)

      this.userId = user.id;

      return user;
    }
  },
  created() {
    this.getLatestMileage();
    this.getUsers();
  }
}
</script>

<style scoped>

.add-mileage {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: white;
  padding: 10px;

  z-index: 2;
}

.footer {
  display: flex;
  justify-content: space-evenly;
}

.input {
  margin: 0 0 20px 0;
}

input {

}

.black {
  color: #00a1ae
}

</style>



// WEBPACK FOOTER //
// src/components/AddMileage.vue